// src/pages/Auth/components/ForgotPasswordStep.js

import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { LOADING_STATES } from '../constants';
import { StyledInput, StyledButton } from '../styles/Styles';
import { validateEmail } from '../utils';

const ForgotPasswordStep = ({ isDarkMode, loadingState, onSubmit, onBack }) => {
  const [forgotEmail, setForgotEmail] = useState('');
  const [localMessage, setLocalMessage] = useState('');
  const [localSuccess, setLocalSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(forgotEmail)) {
      setLocalMessage("Please enter a valid email address.");
      setLocalSuccess(false);
      return;
    }

    setLocalMessage('');
    const result = await onSubmit(forgotEmail);
    
    if (result.success) {
      setLocalSuccess(true);
      setLocalMessage(result.message);
    } else {
      setLocalSuccess(false);
      setLocalMessage(result.message);
    }
  };

  const isLoading = loadingState === LOADING_STATES.FORGOT_PASSWORD;

  return (
    <form onSubmit={handleSubmit}>
      <Box>
        <Box mb={3}>
          <Typography 
            component="label" 
            htmlFor="forgot-email"
            sx={{ 
              fontSize: "14px", 
              fontWeight: "600", 
              marginBottom: "8px", 
              display: "block",
              color: isDarkMode ? "#e2e8f0" : "#374151"
            }}
          >
            Email Address
          </Typography>
          <StyledInput
            id="forgot-email"
            type="email"
            value={forgotEmail}
            onChange={(e) => setForgotEmail(e.target.value)}
            required
            placeholder="Enter your email address"
            isDarkMode={isDarkMode}
          />
        </Box>

        {localMessage && (
          <Typography
            variant="body2"
            align="center"
            sx={{
              mb: 2,
              color: localSuccess ? "success.main" : "error.main",
              fontSize: "0.95rem",
            }}
          >
            {localMessage}
          </Typography>
        )}

        <StyledButton
          type="submit"
          variant="contained"
          fullWidth
          disabled={isLoading || localSuccess}
          isDarkMode={isDarkMode}
          sx={{
            backgroundColor: localSuccess ? (isDarkMode ? "#2d2d3f" : "#ccc") : undefined,
            '&:hover': {
              backgroundColor: localSuccess ? (isDarkMode ? "#2d2d3f" : "#ccc") : undefined,
            }
          }}
        >
          {isLoading ? "Sending..." : localSuccess ? "Reset Link Sent" : "Send Reset Link"}
        </StyledButton>

        <Button
          variant="text"
          fullWidth
          onClick={onBack}
          sx={{
            mt: 2,
            color: "#219297",
            textTransform: "none",
            fontWeight: 500,
            fontSize: "14px",
            "&:hover": {
              backgroundColor: isDarkMode ? "#2d2d3f" : "#f0fdfa",
            },
          }}
        >
          ← Change Email Address
        </Button>
      </Box>
    </form>
  );
};

export default React.memo(ForgotPasswordStep);